export enum ImageType {
  EVENTBACKGROUND = 'background',
  EVENTPICTURE = 'picture',
  EVENTADDITIONALSITES = 'additionalSites',
  SAVEDATEBACKGROUND = 'saveDateBackground',
  SAVEDATEFRONT = 'saveDateFront',
  RSVPMAIN = 'rsvp',
  RSVPBACKGROUND = 'rsvpBackground',
  RSVPWISHES = 'rsvpWishes',
  RSVPFORM = 'rsvpForm',
}
